// Note: This file is where the very first custom Javascript code runs. (it's the first file imported from Main.ts, and imports run before the file itself)

import "./Start_0"; // fake/empty import, so this module is correctly seen as module (rather than raw js script)

// special, early, definitely-safe codes
var g = window as any;
declare global { const g; } g.g = g;

var __webpack_require__;
g.webpackData = __webpack_require__;

const isBot = /bot|crawler|spider|robot|crawling|google|bing|duckduckgo|msn|slurp|yandex|baidu|aolbuild|teoma/i.test(navigator.userAgent);
//declare global { const isBot: string; } g.Extend({isBot});
declare global { const isBot: string; } g.isBot = isBot;

//const inElectron = navigator.userAgent.toLowerCase().includes(" electron");
const inElectron = navigator.userAgent == "Chrome"; // fake user-agent set in lf-desktop
declare global { const inElectron: boolean; } g.inElectron = inElectron;

function ShowBotMessage(message) {
	if (document.body == null) {
		g.addEventListener("load", ()=>ShowBotMessage(message));
		return;
	}

	const container = document.createElement("div");
	container.style.color = "red";
	container.style.position = "fixed";
	container.style.background = "#eee";
	container.style.padding = "2em";
	container.style.top = "1em";
	container.style.left = "1em";

	const msg = document.createElement("pre");
	msg.innerText = message;
	container.appendChild(msg);

	document.body.appendChild(container);
}
if (location.href.indexOf("bot-test-1") != -1) {
	ShowBotMessage(`isBot: ${isBot}`);
}

// browser-check
var {GetBrowser, supportedBrowsers} = require("../General/UserAgent");

var browser = GetBrowser().name || navigator.userAgent;
if (supportedBrowsers.indexOf(browser) == -1 && !isBot) {
	var message = `Sorry! Your browser (${browser}) is not supported. Please use a supported browser such as Chrome, Firefox, or Safari.`;
	setTimeout(()=>{
		try {
			//g.runInAction() (g.store as import("Store").RootState).main.notificationMessages.push(new g.NotificationMessage(message));
			g.AddNotificationMessage(message);
		} catch (ex) {
			alert(message);
		}
	});
}

// special, early codes
// mwahahaha!! React can no longer freeze its objects, so we can do as we please
const fakeFrozenObjects = new WeakSet();
function isPrimitive(val) {
	return val == null || (typeof val != "object" && typeof val != "function");
}
Object.freeze = obj=>{
	if (!isPrimitive(obj)) fakeFrozenObjects.add(obj);
	return obj;
};
Object.isFrozen = obj=>{
	if (isPrimitive(obj)) return true;
	return fakeFrozenObjects.has(obj);
};

// store the original console.log (prior to monkey-patching by sentry, and own code/libraries), for use by Log_Direct in Logging.ts
console["log_orig"] = console.log;

// set this up, so we can see Googlebot errors! (in "Fetch as Google" panel)
if (isBot) {
	g.onerror = function(message, url, line, column, error) {
		console.log(arguments);

		ShowBotMessage(
`Message: ${message}
URL: ${url}
Line: ${line}
Column: ${column}
Stack: ${error && error.stack}`,
		);
	};
}

/*declare global { function G(...globalHolders); } g.G = G;
function G(...globalHolders) {
	for (let globalHolder of globalHolders) {
		g.Extend(globalHolder);
	}
}*/